<div *ngIf="{data: boletines$ | async} as boletines">
  <div *ngIf="boletines.data !== null">
    <div *ngIf="boletines.data.length > 0">
      <h3 class="mat-h3">{{labelMisBoletines()}}</h3>
      <div class="cards-container">
        <div *ngFor="let reconocimientoObj of boletines.data; index as i">
          <div class="avoid-break">
            <app-reconcocimiento-card-categoria [hijoId]="hijoId" [boletinesObj]="reconocimientoObj">
            </app-reconcocimiento-card-categoria>
          </div>
          <div *ngIf="i < boletines.data.length -1" class="premiacion-card__content">
            <mat-divider></mat-divider>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>